module.exports = angular.module('msi.payments.edit', [
  'ui.router',
  require('@ordergroove/brandy/src/app/toasts'),
  require('../payment.service')
]).name;

angular.module(module.exports)
  .config(require('./state'));
